import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { CpxHandleService } from 'src/app/services/cpx-handle/cpx-handle.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { InsRealservice } from 'src/app/services/ins/ins.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { IdentityToCheck } from 'src/app/utils/interfaces/new/identity-to-check';

@Component({
  selector: 'app-verification-insi',
  templateUrl: './verification-insi.component.html',
  styleUrls: ['./verification-insi.component.scss']
})
export class VerificationInsiComponent implements OnInit {

  public pageTitle = 'Vérification INSi en masse';

  private __resourceId: string;
  private get _resourceId(): string | undefined {
    if (!this.__resourceId || this.__resourceId === '') {
      const currentProfilStr = localStorage.getItem('currentProfil');
      if (currentProfilStr && currentProfilStr !== '') {
        const currentProfil = JSON.parse(currentProfilStr);
        this.__resourceId = currentProfil.id;
      }
    }

    return this.__resourceId;
  }

  constructor(
    private _send: HeaderCommunicationService,
    private _modal: ModalService,
    private _view: ViewContainerRef,
    private _cpxSrv: CpxHandleService,
    private _insSrv: InsRealservice,
    private _patientSrv: PatientService
  ) {
    const head: Header = {
      backPage: 'utilitaires',
      isBack: true,
      title: this.pageTitle,
    };
    this._send.announceHeader(head);
  }

  ngOnInit(): void { }

  public async startMassCheck(): Promise<void> {
    let identites: Array<IdentityToCheck>;
    try {
      identites = await this._patientSrv.getIdentitiesForMassCheck();
    } catch (e) {
    }

    if (identites && identites.length > 0) {
      try {
        this._insSrv.resourceId = this._resourceId;
        await this._insSrv.massCheckInsIdentity(this._view, identites);
      } catch (e) {
      }
    }
  }

}
